import { createAsyncThunk } from '@reduxjs/toolkit';
import DashboardService from '@/services/DashboardService';
import LeadsService from '@/services/LeadsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`FilterBar/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

const getCompanyAgents = handler(
  'getCompanyAgents',
  DashboardService.getCompanyAgents
);

const getCompanyBranches = handler(
  'getCompanyBranches',
  DashboardService.getCompanyBranches
);

const getCompanyTeams = handler(
  'getCompanyTeams',
  DashboardService.getCompanyTeams
);

const getTags = handler('getTags', LeadsService.getLeadsTags);

export { getCompanyAgents, getCompanyBranches, getCompanyTeams, getTags };
